import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ApiService } from "src/app/services/api.service";
import { Account, ClientData } from 'src/app/screens/user-profile/client-data';
import { UrlConstants } from 'src/app/models/urlConstants';
import {
  SignalRConfiguration,
  BroadcastEventListener,
  SignalR,
  ISignalRConnection,
} from "ng2-signalr";
import { ToastrService } from "ngx-toastr";
import { DatePipe } from '@angular/common';
import { MatStepper } from '@angular/material/stepper';
import { CommissionResponse } from 'src/app/models/commission-response';
import { AccountType  } from 'src/app/models/mutualFund';


interface PurchasePower {
  EGP: number;
  USD: number;
  Rated: number;
}


interface BlockingAmount {
  curr: string;
  bookbalance: number;
  activebalance: number;
  availablebalance: number;
  AvailableBalanceForWithdrow: number;
  availablebalancefortransfer: number;
  ChecksUnderCollection: number;
  blkAmt: number;
  withHeldAmt: number;
  netAsset: number;
  crdLmt: number;
  penSell: number;
  penSellCommission: number;
  mrgLmt: number;
  dayCashMar: number;
  pendBuy: number;
  MarginCustodian: number;
}

interface PurchasePowerResponse {
  purchasePower: PurchasePower;
  BlockingAmount: BlockingAmount[];
  MarginPosition: any;
}


@Component({
  selector: 'app-ipo-acc-order-modal',
  templateUrl: './ipo-acc-order-modal.component.html',
  styleUrls: ['./ipo-acc-order-modal.component.scss']
})
export class IpoAccOrderModalComponent implements OnInit {
  lang: string;
  isBuy: boolean = false;
  isIpo: boolean = false;
  clientsAccount: Account[];
  accountSelected: boolean = false;
  accounts: number[] = [1, 2, 3];
  typeSelected: string = null;
  type: string = 'success';
  selectedAccount: any | null = null;
  custodianList: any;
  IPOdetails: any;
  purchasePower: any;
  EgpPurchasePower: any;
  UsdPurchasePower: any;
  IPOBalanceEGP: any;
  IPOBalanceUSD: any;
  maxQuantiyEGP: any;
  maxQuantiyUSD: any;
  isMaxPressed: boolean;
  quantityControl = new FormControl('', [
    Validators.required,
    Validators.pattern(/^-?\d*$/)
  ])
  orderTotal
  avgCommission: number;
  minCommission: number;
  minCommissionUSD: number;
  orderValue: number;
  orderFees: number;
  totalCost: number;
  inputValue: number;
  userPortfolio: ClientData;
  maxQuantity;
  selectedCurr = "Rated";
  selectedAccountRealtionCode;
  selectedAcccountNewPP;
  numberOfAccounts: number = 0;
  accList: any;
  selectedIndex;
  Quantity;
  errorMessage;
  inputCustodian: number;
  sendingOrder: boolean = false;
  isSendingOrder: boolean = false;
  isLoading: boolean = false;
  currentDate: string;
  isStep1Completed: boolean = false;
  isStep2Completed: boolean = false;
  notEntered : boolean =false;
  minQtyIndividual:number;
  maxQtyIndividual:number;
  isLessThanMin:boolean=false;
  isMoreThanMax:boolean=false;
  BASIC: number = AccountType.BASIC;
  MINOR: number = AccountType.MINOR;



  private portfolioConnection: ISignalRConnection;


  constructor(

    @Inject(MAT_DIALOG_DATA) public data,
    private signalR: SignalR,
    public translate: TranslateService,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private _service: ApiService,
    public dialogRef: MatDialogRef<IpoAccOrderModalComponent>,
    private http: HttpClient,
    private apiService: ApiService,
    private toastr: ToastrService,
    private datePipe: DatePipe
  ) {
    this.lang = this.translate.currentLang
    this.isBuy = this.data['isBuy']
    this.clientsAccount = this.data['accounts'];
    this.IPOdetails = this.data['IPO'];
    this.minQtyIndividual = this.IPOdetails.MinQtyIndividual;
    this.maxQtyIndividual = this.IPOdetails.MaxQtyIndividual;
  }

  ngOnInit(): void {
    this.fetchAccounts();
    this.fetchCommissions();
    this.quantityControl.valueChanges.subscribe((value) => {
      this.handleQuantityChange(value);
    });


    if (this.accList.length == 1) {
      this.selectAccount(null, this.accList[0]);
    }
    // this.orderForm.valueChanges.subscribe((val) => {
    //   this.orderTotal =
    //   this.IPOdetails.StockPrice * this.orderForm.get("qty").value;
    // });

  }
  get currenciedPP() {
    try {
      return this.userPortfolio.PurchasePower.purchasePower.Rated;
    } catch (error) { }
  }

  get currenciedPortfolio() {
    switch (this.selectedCurr) {
      case "EGP":
        return this.userPortfolio?.Portfolio.EGPPortfolio;
      case "Rated":
        return this.userPortfolio?.Portfolio.RatedPortfolio;
      case "USD":
        return this.userPortfolio?.Portfolio.USDPortfolio;
    }
  }
  initPortfolioSignalR() {
    // First, check if accList is populated
    if (!this.accList || this.accList.length === 0) {
      return;
    }

    // Log accList to ensure it's populated

    // Check if selectedAccount is defined and valid
    if (!this.selectedAccount.relationCode) {
      return;
    }

    // Find the account in accList that matches the selectedAccount relationCode
    let account = this.accList.find(item => item.relationCode === this.selectedAccount.relationCode);

    if (account) {
      // Log account data to ensure it contains ExchangeCode

      // Extract the exchangeCode from the found account
      let exchangeCode = account.ExchangeCode;

      // Ensure exchangeCode is valid before proceeding
      if (!exchangeCode) {
        return;
      }

      // Setup SignalR configuration
      let config: SignalRConfiguration = new SignalRConfiguration();
      config.url = UrlConstants.backofficeUrl;
      config.hubName = 'ordersHub';
      config.logging = false;

      // Establish SignalR connection
      this.signalR.connect(config).then((res) => {
        this.portfolioConnection = res;

        // Join the SignalR group with the exchangeCode
        this.portfolioConnection.invoke('JoinGroup', exchangeCode);

        // Set up listener for portfolio updates
        let method = new BroadcastEventListener<any>('UpdatePortfolio');
        this.portfolioConnection.listen(method);
        method.subscribe((update) => {
          // Handle portfolio updates (fetch new data)
          this.fetchUserPortfolio();
        });

        // Handle errors during the connection
        this.portfolioConnection.errors.subscribe((res) => {
          this.initPortfolioSignalR(); // Retry connecting if there's an error
        });
      });
    }
  }



  openFundAccount() {
    this.dialogRef.close();
  }

  ngAfterViewInit(): void {


    // this.orderForm.valueChanges.subscribe((val) => {
    //   this.orderTotal = this.IPOdetails.StockPrice * this.orderForm.get("qty").value;
    //   this.orderFees =  this.calculateFees(this.orderTotal);
    //   this.totalCost =  this.orderTotal + this.orderFees ;

    // });
  }


  get isValidOrder() {
    return (
      this.orderTotal <
      (this.IPOdetails.CurrencyId == 2
        ? this.IPOBalanceUSD
        : this.IPOBalanceEGP) && this.orderTotal > 0
    );
  }

  selectAccount(stepper: any, acc: any) {
    this.accountSelected = true;
    this.selectedAccount = acc;
    this.selectedIndex = this.accList.findIndex(account => account === acc);

    //this.isLoading = true;

    this.fetchUserPortfolio(this.selectedAccount)
      .then(() => {
        this.isLoading = false;
        this.cdr.detectChanges();
        stepper.next();
      })
      .catch((error) => {
        this.isLoading = false;
        this.cdr.detectChanges();
      });

    // this.getUserPurchasePower(this.selectedAccount.relationCode).then(() => {
    //   this.cdr.detectChanges();
    //   this.handleQuantityChange('0');
    //   this.calculateMaxQuantity(false);
    //   this.isLoading=false;

    // }).catch((error) => {
    // });    
  }


  calculateMaxQuantity(clicked: boolean) {
    const Balance = this.IPOdetails.CurrencyId == 1 ? this.IPOBalanceEGP : this.IPOBalanceUSD;
    let maxQuantity = Math.floor(Balance / this.IPOdetails.StockPrice);

    while (maxQuantity > 0) {
      const orderValue = maxQuantity * this.IPOdetails.StockPrice;
      const fees = this.calculateFees(orderValue);
      const totalCost = orderValue + fees;

      if (totalCost <= Balance) {
        break;
      }
      maxQuantity--;
    }
    this.maxQuantiyEGP = this.IPOdetails.CurrencyId == 1 ? maxQuantity : this.maxQuantiyEGP;
    this.maxQuantiyUSD = this.IPOdetails.CurrencyId != 1 ? maxQuantity : this.maxQuantiyUSD;
    this.cdr.detectChanges();
    if (clicked) {
      this.handleQuantityChange(maxQuantity.toString());
    }
  }


  OrderCalculate() {
    this.orderValue = this.Quantity * this.IPOdetails.StockPrice

  }
  validateInput() {
    // Ensure inputValue is an integer
    this.inputValue = Math.floor(this.inputValue);

    // If the input is less than 1, set it to 1
    if (this.inputValue < 1) {
      this.inputValue = 1;
      this.errorMessage = "The min value is 1";
    }

    // If the input exceeds the maxQuantity, set it to maxQuantity
    if (this.inputValue > this.maxQuantity) {
      this.inputValue = this.maxQuantity;
      this.errorMessage = "This value exceed max value";

    }

  }

  calculateOrderValue() {
    this.orderValue = this.inputValue * this.IPOdetails.StockPrice

    return this.orderValue

  }




  fetchUserPortfolio(selectedAcc?): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      if (selectedAcc) {
        this.selectedAccountRealtionCode = selectedAcc.relationCode;
      }

      if (!this.selectedAccountRealtionCode) {
        reject('Invalid selected account or relationCode');
        return;
      }

      this.http
        .get(`${UrlConstants.backofficeUrl}/api/Client/GetClientInformation?relationCode=${this.selectedAccountRealtionCode}`)
        .subscribe(
          (res) => {
            this.userPortfolio = res as ClientData;
            this.EgpPurchasePower = this.userPortfolio.PurchasePower.purchasePower.EGP || 0;
            this.UsdPurchasePower = this.userPortfolio.PurchasePower.purchasePower.USD || 0;
            this.IPOBalanceEGP = this.IPOdetails.PaidPer === 0 ? this.EgpPurchasePower : this.EgpPurchasePower * (100 / this.IPOdetails.PaidPer);
            this.IPOBalanceUSD = this.IPOdetails.PaidPer === 0 ? this.UsdPurchasePower : this.UsdPurchasePower * (100 / this.IPOdetails.PaidPer);
            this.IPOBalanceEGP = this.IPOBalanceEGP < 0 ? 0 : this.IPOBalanceEGP;
            this.IPOBalanceUSD = this.IPOBalanceUSD < 0 ? 0 : this.IPOBalanceUSD;
            this.calculateMaxQuantity(false);
            // Fetch custodian list
            this.http
              .get(`${UrlConstants.backofficeUrl}/api/Client/GetClientCustodianList?relationCode=${this.selectedAccountRealtionCode}`)
              .subscribe(
                (custodianRes) => {
                  if (custodianRes) {
                    this.custodianList = custodianRes;
                    if (!this.inputCustodian) {
                      this.f.custodian.patchValue(this.custodianList[0].CustodianCode);
                    }
                    this.f.execRule.patchValue(0);
                    this.f.validTill.patchValue(0);
                  }
                  resolve(); // Resolve after both calls succeed
                },
                (custodianErr) => {
                  reject(custodianErr); // Reject on custodian fetch error
                }
              );
          },
          (err) => {
            reject(err); // Reject on user portfolio fetch error
          }
        );
    });
  }




  getUserPurchasePower(relationCode: string): Promise<void> {
    return new Promise((resolve, reject) => {
      this._service.fetchPurchasePower(relationCode).subscribe(
        (response: PurchasePowerResponse) => {
          if (response && response.purchasePower) {
            this.purchasePower = response.purchasePower;
            this.EgpPurchasePower = this.purchasePower.EGP || 0;
            this.UsdPurchasePower = this.purchasePower.USD || 0;
            this.IPOBalanceEGP = this.EgpPurchasePower * (100 / this.IPOdetails.PaidPer);
            this.IPOBalanceUSD = this.UsdPurchasePower * (100 / this.IPOdetails.PaidPer);
            this.IPOBalanceEGP = this.IPOBalanceEGP < 0 ? 0 : this.IPOBalanceEGP;
            this.IPOBalanceUSD = this.IPOBalanceUSD < 0 ? 0 : this.IPOBalanceUSD;
            resolve();
          } else {
            reject('Invalid response structure');
          }
        },
        (error) => {
          reject(error);
        }
      );
    });
  }
  fetchCommissions() {
    this.http.get<CommissionResponse>(`${UrlConstants.backofficeUrl}/api/Settings/GetConfiguredCommissions`)
      .subscribe((res) => {
        this.avgCommission = res.AvgCommission;
        this.minCommission = res.MinCommission;
        this.minCommissionUSD = res.MinCommissionUSD;
      });


  }
  calculateFees(orderValue) {
    let feePercentage = this.avgCommission;

    if (orderValue == 0) {
      feePercentage == 0;
    }

    let totalFees = orderValue * feePercentage;

    if (this.IPOdetails.CurrencyId == 1) {
      if (totalFees < this.minCommission) {
        totalFees = this.minCommission;
      }
    } else {
      if (totalFees < this.minCommissionUSD) {
        totalFees = this.minCommissionUSD;
      }
    }

    return totalFees;
  }

  fetchAccounts() {
    this.apiService.fetchAccounts().subscribe(
      (res: { accountType: number; relationCode: string; clientNameAr: string; accountTypeAr: string; }[]) => {
        if (res) {
          this.accList = res.filter(acc => acc.accountType === 0 || acc.accountType === 1001);
          if (this.accList.length > 0) {
            this.selectedAccount = this.accList[0];
            this.selectAccount(null, this.selectedAccount)
          }
          this.numberOfAccounts = this.accList.length;
        }
      },
      (err) => {
      }
    );
  }


  handleQuantityChange(value: string): void {
    const filteredValue = value.replace(/[^0-9]/g, ''); // Remove all non-digit characters

    if (filteredValue !== value) {
      this.quantityControl.setValue(filteredValue, { emitEvent: false });
      return;
    }

    if (filteredValue !== value) {
      this.quantityControl.setValue(filteredValue, { emitEvent: false });
      return;
    }
    if (this.minQtyIndividual !== 0) {
      if (parseFloat(filteredValue) < this.minQtyIndividual) {
        this.isLessThanMin = true;
      } else {
        this.isLessThanMin = false;
      }
    }
    if (this.maxQtyIndividual !== 0) {
      if (parseFloat(filteredValue) > this.maxQtyIndividual) {
        this.isMoreThanMax = true;
      } else {
        this.isMoreThanMax = false;
      }
    }

    const trimmedValue = filteredValue.replace(/^0+/, '') || '';
    this.quantityControl.setValue(trimmedValue, { emitEvent: false });

    this.orderValue = parseFloat((this.IPOdetails.StockPrice * parseFloat(trimmedValue)).toFixed(2));
    this.orderValue = isNaN(this.orderValue) || this.orderValue < 0 ? 0 : this.orderValue;

    this.orderFees = parseFloat(this.calculateFees(this.orderValue).toFixed(2));
    this.orderFees = isNaN(this.orderFees) || this.orderFees < 0 ? 0 : this.orderFees;

    this.orderTotal = parseFloat((this.orderValue + this.orderFees).toFixed(2));
    this.orderTotal = isNaN(this.orderTotal) || this.orderTotal < 0 ? 0 : this.orderTotal;
  }


  selectType(stepper: any, event: any, type: string) {
    this.typeSelected = type;
    this.cdr.detectChanges();
    stepper.next();
    const TARGET = event.currentTarget as HTMLElement;
    var tabs = document.querySelectorAll('.tab-card');
    tabs.forEach(i => i.classList.remove('selectedType'));
    let element = document.getElementById(TARGET.id);
    element?.classList.add('selectedType');

  }

  createOrder(stepper: any) {
    this.currentDate = this.datePipe.transform(new Date(), 'dd-MM-yyyy hh:mm a');

    if (!this.isValidOrder && this.orderValue > 0 && this.quantityControl.value > 0 && !this.isLoading) {
      this.isStep1Completed = false;
      this.stopNavigation(stepper);
      this.cdr.detectChanges();
    } else {
      this.isStep1Completed = true;
      this.cdr.detectChanges();
      setTimeout(() => {
        stepper.next();
      }, 0);
    }
  }


  submitOrder(stepper: any) {
    this.sendOrder(stepper);
    //stepper.next();
  }

  closeModal() {
    this.dialogRef.close();
  }
  custodianName(value) {
    return this.custodianList.find((item) => item.CustodianCode == value)
      .CustodianNameE;
  }

  stopNavigation(stepper: any) {
    const currentStepIndex = stepper.selectedIndex;
    stepper.selectedIndex = currentStepIndex;
  }




  sendOrder(stepper: any) {

    // Ensure precision for order total
    this.orderTotal = parseFloat(this.orderTotal.toFixed(2));

    // Validate purchase power
    if (
      (this.IPOdetails.CurrencyId === 1 && this.IPOBalanceEGP > this.orderTotal) ||
      (this.IPOdetails.CurrencyId === 2 && this.IPOBalanceUSD > this.orderTotal)
    ) {
      this.sendingOrder = true; 
      this.isSendingOrder=true;

      const orderPayload = {
        SymbolCode: this.IPOdetails.SymbolCode,
        Qty: this.quantityControl.value,
        Price: this.IPOdetails.StockPrice,
        Remark: "OPR",
        TakeMarketPrice: true,
        ISMSCDBook: false,
        OrderType: 1,
        TiffFlag: 1,
        TiffDate: this.orderForm.get("tiffDate").value,
        FillFlag: this.orderForm.get("execRule").value,
        relationCode: this.selectedAccount.relationCode,
        CustodianCode: this.orderForm.get("custodian").value,
        ISOPR: true,
        MinFillVolume: this.orderForm.get("minFillVolume").value,
      };

      // Send API request
      this.http.post(`${UrlConstants.backofficeUrl}/api/Orders/PostOrder`, orderPayload).subscribe({
        next: (res) => {
          if (res["Errors"]?.length > 0) {
            this.sendingOrder = false;
            this.isSendingOrder = false;
            this.toastr.error("", this.translate.instant(res["Errors"][0]), {
              timeOut: 15000,
              positionClass: "toast-bottom-center",
              closeButton: true,
            });
          } else {
            this.sendingOrder = true;
            this.isSendingOrder = false;
            this.toastr.info("", this.translate.instant("new-order-success"), {
              timeOut: 15000,
              positionClass: "toast-bottom-center",
              closeButton: true,
            });
            this.cdr.detectChanges();
            this.isStep2Completed = true;
            setTimeout(() => {
              stepper.next();
            }, 0);
          }
        },
        error: (err) => {
          this.sendingOrder = false;
          this.isSendingOrder = false;
          this.toastr.error("", this.translate.instant("order-failure"), {
            timeOut: 15000,
            positionClass: "toast-bottom-center",
            closeButton: true,
          });
          this.cdr.detectChanges();
          this.isStep2Completed = false;
        },
      });
    } else {
      this.toastr.warning("", this.translate.instant("insufficient-funds"), {
        timeOut: 15000,
        positionClass: "toast-bottom-center",
        closeButton: true,
      });
    }
  }


  get f() {
    return this.orderForm.controls;
  }
  orderForm = new FormGroup({
    client: new FormControl("", Validators.required),
    qty: new FormControl("", Validators.required),
    price: new FormControl("", Validators.required),
    custodian: new FormControl("", Validators.required),
    execRule: new FormControl("", Validators.required),
    validTill: new FormControl("", Validators.required),
    tiffDate: new FormControl(),
    tiffFlag: new FormControl(),
    minFillVolume: new FormControl(),
  });

}

















